module.exports = __webpack_public_path__ + "img/新版-我们_背景.13b4116c.jpg";